import { colors } from '../../theme';

const styles = {
  root: {
    position: 'relative',
    display: 'inline-flex',
    minWidth: 0,
    cursor: 'pointer',
    borderRadius: '10px',
    '&:hover .locked-lock': {
      color: colors.text,
    },
    '&:focus-visible': {
      outline: `2px solid ${colors.borderFocus}`,
    },
  },
  // In a cell of the filter bar: as wide as the cell, like the select of the connected version.
  rootFull: {
    display: 'flex',
    width: '100%',
  },
  // The control looks like the connected one (not dimmed): only the lock tells it is reserved.
  content: {
    display: 'flex',
    flexGrow: 1,
    minWidth: 0,
    pointerEvents: 'none',
    '& > *': {
      flexGrow: 1,
    },
    // The lock takes the place of the chevron.
    '& .MuiSelect-icon, & .locked-chevron': {
      visibility: 'hidden',
    },
  },
  lock: {
    position: 'absolute',
    top: '50%',
    right: 10,
    transform: 'translateY(-50%)',
    fontSize: 16,
    color: colors.textSecondary,
    pointerEvents: 'none',
    transition: 'color 0.15s',
  },
};

export default styles;
